import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { FeaturedVoiceSkeletonWrapper, InfoGroup } from './index.style';

const SkeletonText = ({ width }) => (
  <Skeleton
    style={{ borderRadius: '50px' }}
    variant="rectangular"
    width={width}
    height={12}
  />
);

const SkeletonCircle = ({ size }) => (
  <Skeleton variant="circular" width={size} height={size} />
);

const FeaturedVoiceSkeleton = () => (
  <FeaturedVoiceSkeletonWrapper>
    <Box display="flex" gap="16px">
      <SkeletonCircle size={40} />
      <Box display="flex" flexDirection="column" gap="8px">
        <InfoGroup>
          <SkeletonText width={115} />
          <Box display="flex" gap={1} alignItems="center">
            <SkeletonText width={68} />
          </Box>
        </InfoGroup>
        <Box display="flex" alignItems="center" gap="32px">
          {[...Array(2)].map((_) => (
            <Box key={_} display="flex" gap="8px" alignItems="center">
              <SkeletonCircle size={16} />
              <SkeletonText width={26} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  </FeaturedVoiceSkeletonWrapper>
);

export default FeaturedVoiceSkeleton;
